<template>
  <div class="driver-overview-wrap">
    <v-row>
      <v-col cols="9">
        <v-row>
          <v-col cols="4">
            <drivers-engagement
              :activeDriver="activeDriver"
              :activeSubdriver="activeSubdriver"
            ></drivers-engagement>
          </v-col>
          <v-col cols="8">
            <drivers-responses
            ></drivers-responses>
          </v-col>
        </v-row>
        <v-row class="ma-0">
          <v-col cols="12" class="driver-demo-chart box-container">
            <div>
              <span class="bar-heading">Demographic wise &nbsp;</span>
              <span class="bar-heading" v-if="activeSubdriver">{{activeSubdriver.replace(/([a-z0-9])([A-Z])/g, '$1 $2')}}</span>
              <span class="bar-heading" v-else>{{activeDriver.replace(/([a-z0-9])([A-Z])/g, '$1 $2')}}</span>
              <span class="bar-heading">&nbsp;score</span>
            </div>
            <driver-demographic
              :activeDriver="activeDriver"
              :activeSubdriver="activeSubdriver"
              :activeQuestion="activeQuestion"
              :sort-by-data="sortByData"
            ></driver-demographic>
          </v-col>
        </v-row>
      </v-col>
      <v-col cols="3">
        <div class="driver-lifecycle-wrap">
          <div class="lifecycle-wrap">
            <div class="lifecycle-heading">Touchpoints covered</div>
            <v-row class="lifecycle-body" dense>
              <v-col cols="12"
                v-for="(m, index) in driverData.milestone_wise_analysis"
                :key="index"
              >
                <div class="driver-overview-card">
                  <div class="driver-donut">
                    <v-progress-circular
                      :rotate="270"
                      :size="80"
                      :width="10"
                      :value="m.driver_average*2*10"
                      color="primary"
                    >
                      <span class="driver-score" v-if="m.driver_average">
                        {{m.driver_average.toFixed(1)}}
                      </span>
                      <span class="driver-score" v-else>
                        0.0
                      </span>
                    </v-progress-circular>
                  </div>
                  <div class="driver-title">
                    <span v-if="m.milestone_name">
                      {{m.milestone_name}}
                    </span>
                    <span v-else>
                      --
                    </span>
                  </div>
                  <div class="driver-footer">
                    <div class="driver-stats s-negative">
                      <span v-if="m.negative_responses">{{m.negative_responses}}</span>
                      <span v-else>
                        0
                      </span>
                    </div>
                    <div class="driver-stats s-neutral">
                      <span v-if="m.neutral_responses">{{m.neutral_responses}}</span>
                      <span v-else>
                        0
                      </span>
                    </div>
                    <div class="driver-stats s-positive">
                      <span v-if="m.positive_responses">{{m.positive_responses}}</span>
                      <span v-else>
                        0
                      </span>
                    </div>
                  </div>
                </div>
              </v-col>
            </v-row>
          </div>
        </div>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import DriversEngagement from './drivers-engagement';
import DriversResponses from './drivers-responses';
import DriverDemographic from './driver-demographic';

import DriversMixin from '../drivers-mixins';

export default {
  name: 'DriverOverview',

  mixins: [DriversMixin],

  props: {
    activeDriver: {
      required: true,
      type: String
    },
    activeSubdriver: {
      required: true,
      type: String
    },
    activeQuestion: {
      required: false,
      type: String
    },
    sortByData: {
      required: true,
      type: Object
    }
  },

  components: {
    DriversEngagement,
    DriversResponses,
    DriverDemographic
  }
};
</script>

<style lang="scss" scoped>
.driver-overview-wrap {
  .driver-demo-chart {
    box-shadow: 0 4px 16px 11px rgba(0, 0, 0, 0.06),0 4px 8px rgba(0, 0, 0, 0.1) !important;
    // margin: 0 12px;
    padding: 16px;
  }
  .bar-heading {
    font-size: var(--content-size);
    color: var(--color-text);
    padding-bottom: 16px;
    font-size: 24px;
    font-weight: var(--heading-weight);
    color: var(--color-content);
  }
  .driver-lifecycle-wrap {
    // margin-right: 12px;
    padding: 12px 0px;
    .lifecycle-wrap {
      padding: 16px;
      height: 48rem;
      background-color: var(--bg);
      border-radius: 0.375rem !important;
      position: relative !important;
      border: none !important;
      // box-shadow: 0 4px 20px 1px rgba(0, 0, 0, 0.06), 0 1px 4px rgba(0, 0, 0, 0.08) !important;
      box-shadow: 0 4px 16px 11px rgba(0, 0, 0, 0.06),0 4px 8px rgba(0, 0, 0, 0.1) !important;
      .lifecycle-heading {
        text-align: center;
        color: var(--color-text);
        padding-bottom: 12px;
      }
      .lifecycle-body {
        display: block;
        overflow-y: auto;
        height: 43rem;
        padding: 0 12px;
      }
    }
    .driver-overview-card {
      background: var(--bg);
      padding: 16px;
      text-align: center;
      height: 12rem;
      border-radius: 6px;
      box-shadow:
      // 3px 3px 12px 0 rgba(0, 0, 0, 0.06) inset,
      // -3px -3px 12px 0 rgba(0, 0, 0, 0.06) inset;
      3px 3px 9px 0 #ebe9ff inset,
      -3px -3px 9px 0 #ebe9ff inset;
      transition: 0.5s;
      box-shadow: 0 4px 16px 11px rgba(0, 0, 0, 0.06),0 4px 8px rgba(0, 0, 0, 0.1) !important;
      -webkit-transition: 0.5s;
      &:hover {
        transform: scale(1.05);
      }
      .driver-title {
        margin: 6px 0 12px 0;
        // font-size: var(--content-size);
        font-size: var(--heading-size);
        height: 2rem;
        color: var(--color-text);
      }
      .driver-score {
        font-size: var(--content-size);
        // font-size: var(--stats-size-1);
        color: var(--color-text);
        font-weight: var(--heading-weight);
      }
      .driver-footer {
        display: flex;
        justify-content: space-evenly;
        padding: 0 30px;
        .driver-stats {
          padding: 4px 6px;
          display: flex;
          justify-content: center;
          align-items: center;
          border-radius: 4px;
          color: var(--color-text);
          font-size: var(--content-sub-size);
          box-shadow:
          // 2px 2px 6px 0 rgba(0, 0, 0, 0.06),
          // -2px -2px 6px 0 rgba(0, 0, 0, 0.06);
          2px 2px 6px 0 #ebe9ff,
          -2px -2px 6px 0 #ebe9ff;
          &.s-negative {
            background-color: rgba(244, 67, 54, 0.2);
          }
          &.s-neutral {
            background-color: rgba(246, 251, 252, 0.2);
          }
          &.s-positive {
            background-color: rgba(100, 231, 100, 0.2);
          }
        }
      }
    }
  }
}
</style>
